/* eslint-disable react/no-unescaped-entities */
import { useTranslation } from "next-i18next"
import { useRouter } from "next/router"
import Header from "../components/Header"
import Footer from "../components/local/Footer"

export { getServerSideProps } from "../utils/getServerSideProps"

const TermsAndConditionsEN = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4">Terms and Conditions</h1>
      <div className="text-black mb-8">Last updated: 29/Apr/2023</div>
      <h2 className="text-2xl font-bold mb-2">1. Use of Our Services</h2>
      <div className="mb-8">
        Our Services are intended for users who are 18 years of age or older. By
        using our Services, you represent that you are at least 18. We reserve
        the right to refuse service to anyone for any reason.
      </div>
      <h2 className="text-2xl font-bold mb-2">2. Disclaimer</h2>
      <div className="mb-8">
        Our Services are not a substitute for professional advice or treatment.
        The information provided by our Services is for general informational
        purposes only and should not be relied upon as a substitute for
        professional advice or treatment. Our Services may sometimes provide
        inaccurate results and are unsuitable for individuals experiencing a
        suicidal crisis. If you are experiencing a mental health emergency, do
        not hesitate to contact your local emergency services or a crisis
        hotline.
      </div>
      <h2 className="text-2xl font-bold mb-2">3. Personal Information</h2>
      <div className="mb-8">
        When you use our Services, we collect certain personal information from
        you, including your name, email address, and phone number, for account
        verification and voice recordings of your interactions with our tool,
        with your consent, to improve future sessions. We use cookies and other
        tracking technologies on our website for analytics purposes. We share
        your personal information with trusted third-party service providers for
        specific purposes, such as technology partners to assist in providing
        and improving our Services, cloud storage service providers for storing
        user data, and web hosting service providers for hosting our website and
        services. We store your personal information for as long as you want us
        to. We use HTTPS connections to transfer data, strong cryptography to
        store passwords, and a backup policy and disaster recovery plan to
        ensure your information's security. We currently do not provide users
        with options to access, correct, or delete their personal information
        stored on our website. We plan to add these features in the future.
      </div>

      <h2 className="text-2xl font-bold mb-2">4. Intellectual Property</h2>
      <div className="mb-8">
        Our app and its entire contents, features, and functionality (including
        but not limited to all information, software, text, displays, images,
        video, audio, and the design, selection, and arrangement thereof) are
        owned by us or our licensors. The United States and international
        copyright, trademark, patent, trade secret, and other intellectual
        property or proprietary rights laws protect them.
      </div>
      <h2 className="text-2xl font-bold mb-2">5. Limitation of Liability</h2>
      <div className="mb-8">
        In no event shall we be liable for any indirect, incidental, special,
        consequential, or punitive damages, including but not limited to loss of
        profits, data, or use, arising out of or in connection with our Services
        or these Terms.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        6. Changes to Our Terms and Conditions
      </h2>
      <div className="mb-8">
        At our sole discretion, we reserve the right to modify or replace these
        Terms at any time. If we make any material changes to these Terms, we
        will notify you by email. Your continued use of our Services after any
        such changes constitutes your acceptance of the new Terms.
      </div>
      <h2 className="text-2xl font-bold mb-2">7. Governing Law</h2>
      <div className="mb-8">
        These Terms shall be governed by and construed per the laws of the
        United States without giving effect to any principles of conflicts of
        law.
      </div>
      <h2 className="text-2xl font-bold mb-2">8. Contacting Us</h2>
      <div className="mb-8">
        If you have any questions or concerns about these Terms, don't hesitate
        to contact us at{" "}
        <a
          href="mailto:hello@mind-r.ai"
          className="text-blue-600 hover:text-blue-800"
        >
          hello@mind-r.ai
        </a>
        .
      </div>
      <div className="mb-8">
        By using our Services, you agree to these Terms. If you do not agree
        with any part of these Terms, you should not use our Services.
      </div>
    </div>
  )
}

const TermsAndConditionsIT = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4">Informativa sulla Privacy</h1>
      <div className="text-black mb-8">Ultimo aggiornamento: 9/Giu/2023</div>
      <h2 className="text-2xl font-bold mb-2">
        1. Informazioni personali che raccogliamo
      </h2>
      <div className="mb-8">
        Quando usi i nostri Servizi, raccogliamo le seguenti informazioni
        personali da te:
      </div>
      <ul className="mb-8">
        <li>Nome</li>
        <li>Indirizzo email</li>
        <li>Il numero di telefono per la verifica dell'account</li>
        <li>
          Registrazioni vocali delle tue interazioni con il nostro strumento,
          con il tuo consenso, per migliorare le sessioni future
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-2">
        2. Utilizzo di Cookies e altre tecnologie di tracciamento
      </h2>
      <div className="mb-8">
        Utilizziamo i cookies e altre tecnologie di tracciamento sul nostro sito
        web per fini di analisi.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        3. Condivisione delle informazioni personali con terze parti
      </h2>
      <div className="mb-8">
        Condividiamo le tue informazioni personali con fornitori di servizi di
        fiducia per scopi specifici:
      </div>
      <ul className="mb-8">
        <li>
          Partner tecnologici per assistere nella fornitura e migliorare i
          nostri Servizi
        </li>
        <li>
          Fornitori di servizi di archiviazione cloud per l'archiviazione dei
          dati degli utenti
        </li>
        <li>
          Fornitori di servizi di hosting web per l'hosting del nostro sito web
          e dei servizi
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-2">
        4. Archiviazione e sicurezza dei dati
      </h2>
      <div className="mb-8">
        Conserviamo le tue informazioni personali per tutto il tempo che
        desideri. Utilizziamo connessioni HTTPS per trasferire i dati,
        crittografia robusta per archiviare le password, e una politica di
        backup e un piano di ripristino di emergenza per garantire la sicurezza
        delle tue informazioni.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        5. Accesso, correzione e cancellazione delle informazioni personali
      </h2>
      <div className="mb-8">
        Attualmente non forniamo agli utenti opzioni per accedere, correggere o
        cancellare le loro informazioni personali archiviate sul nostro sito
        web. Abbiamo in programma di aggiungere queste funzioni in futuro.
      </div>
      <h2 className="text-2xl font-bold mb-2">6. Requisito di età</h2>
      <div className="mb-8">
        I nostri Servizi sono destinati agli utenti che hanno 18 anni o più.
        Utilizzando i nostri Servizi, rappresenti di avere almeno 18 anni.
      </div>
      <h2 className="text-2xl font-bold mb-2">7. Contattaci</h2>
      <div className="mb-8">
        Se hai domande o dubbi sulla privacy, ti preghiamo di contattarci
        all'indirizzo{" "}
        <a
          href="mailto:hello@mind-r.ai"
          className="text-blue-600 hover:text-blue-800"
        >
          hello@mind-r.ai
        </a>
        .
      </div>
      <h2 className="text-2xl font-bold mb-2">
        8. Modifiche alla nostra Informativa sulla Privacy
      </h2>
      <div className="mb-8">
        Ti invieremo una email per notificare eventuali modifiche significative
        a questa Informativa sulla Privacy. Ti invitiamo a rivedere
        periodicamente questa Informativa sulla Privacy per rimanere informato
        sulle nostre pratiche di privacy.
      </div>
      <div className="mb-8">
        Utilizzando i nostri Servizi, accetti la raccolta, l'utilizzo e la
        divulgazione delle tue informazioni personali come descritto in questa
        Informativa sulla Privacy. Se non sei d'accordo con una qualsiasi parte
        di questa Informativa sulla Privacy, non dovresti utilizzare i nostri
        Servizi.
      </div>
    </div>
  )
}

const TermsAndConditionsFR = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4">Politique de confidentialité</h1>
      <div className="text-black mb-8">Dernière mise à jour : 9 juin 2023</div>
      <h2 className="text-2xl font-bold mb-2">
        1. Informations personnelles que nous collectons
      </h2>
      <div className="mb-8">
        Lorsque vous utilisez nos services, nous collectons les informations
        personnelles suivantes vous concernant :
      </div>
      <ul className="mb-8">
        <li>Nom</li>
        <li>Adresse e-mail</li>
        <li>Le numéro de téléphone pour la vérification du compte</li>
        <li>
          Des enregistrements vocaux de vos interactions avec notre outil, avec
          votre consentement, pour améliorer les sessions futures
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-2">
        2. Utilisation de cookies et de technologies de suivi
      </h2>
      <div className="mb-8">
        Nous utilisons des cookies et d'autres technologies de suivi sur notre
        site Web à des fins d'analyse.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        3. Partage d'informations personnelles avec des tiers
      </h2>
      <div className="mb-8">
        Nous partageons vos informations personnelles avec des prestataires de
        services tiers de confiance pour des fins spécifiques :
      </div>
      <ul className="mb-8">
        <li>
          Des partenaires technologiques pour aider à fournir et améliorer nos
          services
        </li>
        <li>
          Des fournisseurs de services de stockage cloud pour stocker les
          données utilisateur
        </li>
        <li>
          Des fournisseurs de services d'hébergement Web pour héberger notre
          site Web et nos services
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-2">
        4. Stockage et sécurité des données
      </h2>
      <div className="mb-8">
        Nous stockons vos informations personnelles aussi longtemps que vous le
        souhaitez. Nous utilisons des connexions HTTPS pour transférer des
        données, une cryptographie forte pour stocker les mots de passe, et une
        politique de sauvegarde et un plan de reprise après sinistre pour
        assurer la sécurité de vos informations.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        5. Accès, correction et suppression des informations personnelles
      </h2>
      <div className="mb-8">
        Nous ne proposons actuellement pas aux utilisateurs d'options d'accès,
        de correction ou de suppression de leurs informations personnelles
        stockées sur notre site Web. Nous prévoyons d'ajouter ces
        fonctionnalités à l'avenir.
      </div>
      <h2 className="text-2xl font-bold mb-2">6. Exigence d'âge</h2>
      <div className="mb-8">
        Nos services sont destinés aux utilisateurs âgés de 18 ans ou plus. En
        utilisant nos services, vous déclarez que vous avez au moins 18 ans.
      </div>
      <h2 className="text-2xl font-bold mb-2">7. Nous contacter</h2>
      <div className="mb-8">
        Si vous avez des questions ou des préoccupations concernant la
        confidentialité, veuillez nous contacter à l'adresse suivante :{" "}
        <a
          href="mailto:hello@mind-r.ai"
          className="text-blue-600 hover:text-blue-800"
        >
          hello@mind-r.ai
        </a>
        .
      </div>
      <h2 className="text-2xl font-bold mb-2">
        8. Modifications de notre politique de confidentialité
      </h2>
      <div className="mb-8">
        Nous vous enverrons un e-mail pour vous informer des changements
        importants apportés à cette politique de confidentialité. Nous vous
        encourageons à consulter régulièrement cette politique de
        confidentialité pour vous informer de nos pratiques en matière de
        confidentialité.
      </div>
      <div className="mb-8">
        En utilisant nos services, vous acceptez la collecte, l'utilisation et
        la divulgation de vos informations personnelles telles que décrites dans
        cette politique de confidentialité. Si vous n'êtes pas d'accord avec une
        partie de cette politique de confidentialité, vous ne devriez pas
        utiliser nos services.
      </div>
    </div>
  )
}

const TermsAndConditionsPT = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4">Política de Privacidade</h1>
      <div className="text-black mb-8">Última atualização: 9/Jun/2023</div>
      <h2 className="text-2xl font-bold mb-2">
        1. Informações Pessoais que Coletamos
      </h2>
      <div className="mb-8">
        Quando você usa nossos Serviços, coletamos as seguintes informações
        pessoais de você:
      </div>
      <ul className="mb-8">
        <li>Nome</li>
        <li>Endereço de e-mail</li>
        <li>Número de telefone para verificação da conta</li>
        <li>
          Gravações de voz de suas interações com nossa ferramenta, com seu
          consentimento, para melhorar sessões futuras
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-2">
        2. Uso de Cookies e Tecnologias de Rastreamento
      </h2>
      <div className="mb-8">
        Utilizamos cookies e outras tecnologias de rastreamento em nosso site
        para fins de análise.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        3. Compartilhamento de Informações Pessoais com Terceiros
      </h2>
      <div className="mb-8">
        Compartilhamos suas informações pessoais com provedores de serviços
        terceirizados confiáveis para fins específicos:
      </div>
      <ul className="mb-8">
        <li>
          Parceiros de tecnologia para ajudar a fornecer e melhorar nossos
          serviços
        </li>
        <li>
          Provedores de serviços de armazenamento em nuvem para armazenar dados
          do usuário
        </li>
        <li>
          Provedores de serviços de hospedagem na web para hospedar nosso site e
          serviços
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-2">
        4. Armazenamento e Segurança de Dados
      </h2>
      <div className="mb-8">
        Armazenamos suas informações pessoais pelo tempo que você desejar.
        Usamos conexões HTTPS para transferir dados, criptografia forte para
        armazenar senhas e uma política de backup e um plano de recuperação de
        desastres para garantir a segurança de suas informações.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        5. Acesso, Correção e Exclusão de Informações Pessoais
      </h2>
      <div className="mb-8">
        Atualmente, não fornecemos aos usuários opções de acesso, correção ou
        exclusão de suas informações pessoais armazenadas em nosso site.
        Planejamos adicionar esses recursos no futuro.
      </div>

      <h2 className="text-2xl font-bold mb-2">6. Requisito de Idade</h2>
      <div className="mb-8">
        Nossos serviços são destinados a usuários com 18 anos de idade ou mais.
        Ao usar nossos serviços, você declara ter pelo menos 18 anos de idade.
      </div>
      <h2 className="text-2xl font-bold mb-2">7. Contato</h2>
      <div className="mb-8">
        Se você tiver alguma dúvida ou preocupação sobre privacidade, entre em
        contato conosco em{" "}
        <a
          href="mailto:hello@mind-r.ai"
          className="text-blue-600 hover:text-blue-800"
        >
          hello@mind-r.ai
        </a>
        .
      </div>
      <h2 className="text-2xl font-bold mb-2">
        8. Alterações em Nossa Política de Privacidade
      </h2>
      <div className="mb-8">
        Enviaremos um e-mail para você com quaisquer alterações significativas
        nesta Política de Privacidade. Encorajamos você a revisar esta Política
        de Privacidade periodicamente para se manter informado sobre nossas
        práticas de privacidade.
      </div>
      <div className="mb-8">
        Ao usar nossos Serviços, você concorda com a coleta, uso e divulgação de
        suas informações pessoais conforme descrito nesta Política de
        Privacidade. Se você não concorda com qualquer parte desta Política de
        Privacidade, não deve usar nossos Serviços.
      </div>
    </div>
  )
}

const TermsAndConditionsES = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4">Política de privacidad</h1>
      <div className="text-black mb-8">Última actualización: 9/Jun/2023</div>
      <h2 className="text-2xl font-bold mb-2">
        1. Información personal que recopilamos
      </h2>
      <div className="mb-8">
        Cuando utiliza nuestros servicios, recopilamos la siguiente información
        personal de usted:
      </div>
      <ul className="mb-8">
        <li>Nombre</li>
        <li>Dirección de correo electrónico</li>
        <li>Número de teléfono para verificación de cuenta</li>
        <li>
          Grabaciones de voz de sus interacciones con nuestra herramienta, con
          su consentimiento, para mejorar futuras sesiones
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-2">
        2. Uso de cookies y tecnologías de seguimiento
      </h2>
      <div className="mb-8">
        Utilizamos cookies y otras tecnologías de seguimiento en nuestro sitio
        web con fines analíticos.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        3. Compartir información personal con terceros
      </h2>
      <div className="mb-8">
        Compartimos su información personal con proveedores de servicios de
        confianza de terceros para fines específicos:
      </div>
      <ul className="mb-8">
        <li>
          Socios tecnológicos para ayudar a proporcionar y mejorar nuestros
          servicios
        </li>
        <li>
          Proveedores de servicios de almacenamiento en la nube para almacenar
          datos de usuario
        </li>
        <li>
          Proveedores de servicios de alojamiento web para alojar nuestro sitio
          y servicios web
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-2">
        4. Almacenamiento y seguridad de datos
      </h2>
      <div className="mb-8">
        Almacenamos su información personal durante el tiempo que desee.
        Utilizamos conexiones HTTPS para transferir datos, una criptografía
        sólida para almacenar contraseñas y una política de copia de seguridad y
        un plan de recuperación de desastres para garantizar la seguridad de su
        información.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        5. Acceso, corrección y eliminación de información personal
      </h2>
      <div className="mb-8">
        Actualmente, no proporcionamos a los usuarios opciones para acceder,
        corregir o eliminar su información personal almacenada en nuestro sitio
        web. Planeamos agregar estas funciones en el futuro.
      </div>

      <h2 className="text-2xl font-bold mb-2">6. Requisito de edad</h2>
      <div className="mb-8">
        Nuestros servicios están destinados a usuarios de 18 años de edad o
        mayores. Al utilizar nuestros servicios, usted declara que tiene al
        menos 18 años de edad.
      </div>
      <h2 className="text-2xl font-bold mb-2">7. Contacto</h2>
      <div className="mb-8">
        Si tiene alguna pregunta o inquietud sobre privacidad, comuníquese con
        nosotros en{" "}
        <a
          href="mailto:hello@mind-r.ai"
          className="text-blue-600 hover:text-blue-800"
        >
          hello@mind-r.ai
        </a>
        .
      </div>
      <h2 className="text-2xl font-bold mb-2">
        8. Cambios en nuestra política de privacidad
      </h2>
      <div className="mb-8">
        Le enviaremos un correo electrónico con cualquier cambio significativo
        en esta Política de privacidad. Le recomendamos que revise
        periódicamente esta Política de privacidad para mantenerse informado
        sobre nuestras prácticas de privacidad.
      </div>
      <div className="mb-8">
        Al utilizar nuestros servicios, acepta la recopilación, uso y
        divulgación de su información personal tal como se describe en esta
        Política de privacidad. Si no está de acuerdo con alguna parte de esta
        Política de privacidad, no debe utilizar nuestros servicios.
      </div>
    </div>
  )
}

const TermsAndConditionsDE = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4">Datenschutzrichtlinie</h1>
      <div className="text-black mb-8">Letzte Aktualisierung: 9. Jun. 2023</div>
      <h2 className="text-2xl font-bold mb-2">
        1. Persönliche Informationen, die wir sammeln
      </h2>
      <div className="mb-8">
        Wenn Sie unsere Dienste nutzen, sammeln wir folgende persönliche
        Informationen von Ihnen:
      </div>
      <ul className="mb-8">
        <li>Name</li>
        <li>E-Mail-Adresse</li>
        <li>Telefonnummer zur Kontoverifizierung</li>
        <li>
          Sprachaufnahmen Ihrer Interaktionen mit unserem Tool, mit Ihrer
          Zustimmung, zur Verbesserung zukünftiger Sitzungen
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-2">
        2. Verwendung von Cookies und Tracking-Technologien
      </h2>
      <div className="mb-8">
        Wir verwenden Cookies und andere Tracking-Technologien auf unserer
        Website zu Analysezwecken.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        3. Weitergabe persönlicher Informationen an Dritte
      </h2>
      <div className="mb-8">
        Wir teilen Ihre persönlichen Informationen mit vertrauenswürdigen
        Drittanbieter-Dienstleistern für spezifische Zwecke:
      </div>
      <ul className="mb-8">
        <li>
          Technologiepartner, um bei der Bereitstellung und Verbesserung unserer
          Dienste zu helfen
        </li>
        <li>Cloud-Speicheranbieter, um Benutzerdaten zu speichern</li>
        <li>
          Webhosting-Dienstleister, um unsere Website und Webdienste zu hosten
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-2">
        4. Speicherung und Sicherheit von Daten
      </h2>
      <div className="mb-8">
        Wir speichern Ihre persönlichen Informationen so lange, wie Sie möchten.
        Wir verwenden HTTPS-Verbindungen zum Übertragen von Daten, eine starke
        Verschlüsselung zum Speichern von Passwörtern und eine Backup-Policy und
        einen Disaster-Recovery-Plan, um die Sicherheit Ihrer Informationen zu
        gewährleisten.
      </div>
      <h2 className="text-2xl font-bold mb-2">
        5. Zugriff, Korrektur und Löschung persönlicher Informationen
      </h2>
      <div className="mb-8">
        Derzeit bieten wir den Benutzern keine Optionen zum Zugriff, zur
        Korrektur oder Löschung ihrer persönlichen Informationen, die auf
        unserer Website gespeichert sind. Wir planen, diese Funktionen in
        Zukunft hinzuzufügen.
      </div>
      <h2 className="text-2xl font-bold mb-2">6. Altersanforderung</h2>
      <div className="mb-8">
        Unsere Dienste sind für Benutzer ab 18 Jahren oder älter bestimmt. Durch
        die Nutzung unserer Dienste erklären Sie, dass Sie mindestens 18 Jahre
        alt sind.
      </div>
      <h2 className="text-2xl font-bold mb-2">7. Kontakt</h2>
      <div className="mb-8">
        Wenn Sie Fragen oder Bedenken zur Privatsphäre haben, kontaktieren Sie
        uns unter{" "}
        <a
          href="mailto:hello@mind-r.ai"
          className="text-blue-600 hover:text-blue-800"
        >
          hello@mind-r.ai
        </a>
        .
      </div>
      <h2 className="text-2xl font-bold mb-2">
        8. Änderungen unserer Datenschutzrichtlinie
      </h2>
      <div className="mb-8">
        Wir werden Sie per E-Mail über alle wesentlichen Änderungen dieser
        Datenschutzrichtlinie informieren. Wir empfehlen Ihnen, diese
        Datenschutzrichtlinie regelmäßig zu überprüfen, um sich über unsere
        Datenschutzpraktiken auf dem Laufenden zu halten.
      </div>
      <div className="mb-8">
        Durch die Nutzung unserer Dienste erklären Sie sich damit einverstanden,
        dass wir Ihre persönlichen Informationen gemäß dieser
        Datenschutzrichtlinie sammeln, verwenden und offenlegen. Wenn Sie mit
        einem Teil dieser Datenschutzrichtlinie nicht einverstanden sind,
        sollten Sie unsere Dienste nicht nutzen.
      </div>
    </div>
  )
}

function TermsAndConditionsByLang() {
  const { locale } = useRouter()

  const language = locale.substring(0, 2)

  if (language === "pt") {
    return <TermsAndConditionsPT />
  }

  if (language === "es") {
    return <TermsAndConditionsES />
  }

  if (language === "de") {
    return <TermsAndConditionsDE />
  }

  if (language === "fr") {
    return <TermsAndConditionsFR />
  }

  if (language === "it") {
    return <TermsAndConditionsIT />
  }

  return <TermsAndConditionsEN />
}

function TermsAndConditions() {
  const { t } = useTranslation("common")

  return (
    <div className="overflow-hidden text-black font-sans  ">
      <Header logoUrl="/assets/logo-black.png" />

      <div
        className="flex flex-col mt-12 lg:mt-32 lg:pt-1 w-full lg:flex-row "
        id="page-wrap"
      >
        <TermsAndConditionsByLang />
      </div>

      <Footer />
    </div>
  )
}

export default TermsAndConditions
